// "Show more" pagination for the collection section. The button is a real
// link to the next page (works without JS); this intercepts the click,
// fetches that page via the section-rendering endpoint, appends its product
// cards to the current grid and swaps in the next page's "Show more" block.
//
// Delegated from `document` because filter-drawer.js replaces the whole
// [data-collection-results] wrapper (grid + button) after each filter change.
(() => {
  if (window.collectionLoadMoreBound) return;
  window.collectionLoadMoreBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-collection-load-more-button]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    const results = button.closest('[data-collection-results]');
    const section = button.closest('.shopify-section');
    const grid = results && results.querySelector('[data-collection-grid]');
    const sectionId = section && section.id.replace('shopify-section-', '');
    // Without these there's nothing to append to - fall back to the link.
    if (!grid || !sectionId) return;

    event.preventDefault();
    button.setAttribute('aria-busy', 'true');

    const url = new URL(button.href, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    try {
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(`Load more failed: ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

      const nextGrid = doc.querySelector('[data-collection-grid]');
      const newItems = nextGrid ? Array.from(nextGrid.children) : [];
      newItems.forEach((item) => grid.appendChild(document.adoptNode(item)));

      const current = results.querySelector('[data-collection-load-more]');
      const next = doc.querySelector('[data-collection-load-more]');
      if (current && next) current.replaceWith(document.adoptNode(next));

      // Move keyboard / screen-reader users to the first new product rather
      // than leaving focus on a button that may no longer exist.
      const firstLink = newItems[0] && newItems[0].querySelector('a[href]');
      if (firstLink) firstLink.focus({ preventScroll: true });

      document.dispatchEvent(new CustomEvent('collection:products-loaded', { detail: { items: newItems } }));
    } catch (error) {
      window.location.href = button.href;
    } finally {
      button.removeAttribute('aria-busy');
    }
  });
})();
